//
// Generated class ReportLocalized
//

/// <reference path="ReportLocalized_ManagedObject.ts" />

class ReportLocalized extends ReportLocalized_ManagedObject
{

}
